export default function(submitting, defaultIcon) {
    return (submitting ? 'fa fa-spinner fa-spin':defaultIcon)
}


// WEBPACK FOOTER //
// ./src/utils/constants/submittingIcon.js